
namespace TabAurous.JobWork {

    @Serenity.Decorators.registerClass()
    export class JobWorkItemsReturnBOMSelectGrid extends _Ext.GridBase<JobWorkReturnBOMRow, any> {
        protected getColumnsKey() { return 'JobWork.JobWorkReturnBOM'; }
        protected getDialogType() { return <any>JobWorkReturnBOMDialog; }
        protected getIdProperty() { return JobWorkReturnBOMRow.idProperty; }
        protected getLocalTextPrefix() { return JobWorkReturnBOMRow.localTextPrefix; }
        protected getInitialTitle() { return null; };
        //protected getInsertPermission() { return JobWorkRetrunRow.insertPermission; }
        //protected getUpdatePermission() { return JobWorkRetrunRow.updatePermission; }
        //protected getDeletePermission() { return JobWorkRetrunRow.deletePermission; }
        //protected useViewMode() { return true; } 
     
        constructor(container: JQuery, options) {
            super(container, options); 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        private autoSize;
 
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): JobWorkReturnBOMRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    } 
}